import 'core-js/stable'
import { createApp } from 'vue'
import App from './App'
import router from './router'
import CoreuiVue3 from './coreui'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
import axios from "@/api/http";
import i18n from './i18n'
import { bus } from './utils/bus'

import ImageSelector from "./views/includes/ImageSelector";
import CDataTableFixed from "./views/DataTableFixed/CDataTableFixed";
import CInputCurrency from "./views/CInputCurrency/CInputCurrency";
import CInputText from "./views/CInputText/CInputText";
import CLinkSelector from "./views/CLinkSelector/CLinkSelector";
import CIconSelector from "./views/CIconSelector/CIconSelector";
import VuePersianDatetimePicker from 'vue3-persian-datetime-picker';
import SeoProgress from "@/views/includes/SeoProgress.vue";
import SeoBox from "@/views/includes/SeoBox.vue";
import FaqBox from "@/views/includes/FaqBox.vue";
import SearchableSelect from "@/components/SearchableSelect.vue";
import ToastPlugin from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';

import moment from 'moment-jalaali'

import VueHtmlToPaper from './CustomElements/html_paper_print_index';

// kept for modules that still import { bus } from '@/utils/bus'
export { bus }

const app = createApp(App)

app.component('ImageSelector', ImageSelector);
app.component('CDataTableFixed', CDataTableFixed);
app.component('CInputCurrency', CInputCurrency);
app.component('CInputText', CInputText);
app.component('CLinkSelector', CLinkSelector);
app.component('CIconSelector', CIconSelector);
app.component('SeoProgress', SeoProgress);
app.component('SeoBox', SeoBox);
app.component('FaqBox', FaqBox);
app.component('SearchableSelect', SearchableSelect);

const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes',
  ],
  styles: [
    '/css/bootstrap.min.css',
    '/css/print.css?ver=' + process.env.VUE_APP_VERSION,
  ]
}

app.use(VueHtmlToPaper, options);
// axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Global request indicator: a thin, non-blocking top progress bar (see views/includes/LoadingPage.vue).
// Pages render immediately; data-driven parts show their own skeletons. show_pros:false opts a request out.
let pendingRequests = 0
const progressDone = (config) => {
  if (config && config.__progress) {
    pendingRequests = Math.max(0, pendingRequests - 1)
    if (!pendingRequests) bus.$emit("show_spinner", 'false');
  }
}
axios.interceptors.request.use((config) => {
  if (config.show_pros == null) {
    config.__progress = true
    pendingRequests += 1
    bus.$emit("show_spinner", 'true');
  }
  return config;
}, (error) => {
  progressDone(error && error.config)
  return Promise.reject(error);
});

axios.interceptors.response.use((response) => {
  progressDone(response && response.config)
  return response;
}, (error) => {
  progressDone(error && error.config)
  return Promise.reject(error);
});
i18n.locale = 'fa';
var display_time = "";
var start_date = 0;
if (i18n.locale == 'fa') {
  display_time = 'jYYYY/jMM/jDD';
  start_date = 6;
}
if (i18n.locale == 'en') {
  display_time = 'YYYY/MM/DD'

  start_date = 1
}
// registers <date-picker> (same tag as before) with the panel-wide defaults
app.use(VuePersianDatetimePicker, {
  name: 'date-picker',
  props: {
    // min:min_date,
    // max:max_date,
    format: "YYYY-MM-DD",
    inputFormat: 'YYYY-MM-DD',
    displayFormat: display_time,
    editable: true,
    locale: i18n.locale,
    startDate: start_date,
    color: "dimgray",
    altFormat: 'YYYY-MM-DD HH:mm',
    autoSubmit: true,

  }
});
app.config.performance = true
// Vue 2 logged component errors and kept going; Vue 3 re-throws them in development builds.
app.config.errorHandler = (err, vm, info) => { console.error(err, info) }
app.use(CoreuiVue3, { icons })
app.use(ToastPlugin, { position: 'bottom-left' })
app.config.globalProperties.$log = console.log.bind(console)

app.mixin({


      methods: {
        get_currency(number) {
          number = number.toString().replace(/,/g, '');

          var fixed = parseInt(0);
          var final_number = parseFloat(number);
          number = final_number.toFixed(fixed);
          return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
        get_currency_no_fix(number) {
          var final_number = parseFloat(number);

          number = final_number;
          return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
        get_currency_int(number) {
          var final_number = parseInt(number);

          number = final_number
          return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
        currency_symbol() {
          if (localStorage.getItem('currency_symbol') == null || localStorage.getItem('currency_symbol') == 'null') {
            return "";
          } else {
            return " " + localStorage.getItem('currency_symbol') + " "
          }
        },
        calculate_items(list, item) {
          var total = 0;
          // try{
          list.forEach(function (val) {
            if (val[item] != null) {
              val[item] = val[item].toString().replace(/,/g, '');
              total += parseFloat(val[item]);
            }
          })
          return total;
        },
        calculate_items_percent(list, item,amount) {
          var total = 0;
          // try{
          list.forEach(function (val) {
            if (val[item] != null) {
              val[item] = val[item].toString().replace(/,/g, '');
              total += parseFloat(val[item]);
            }
          })
         return (amount*100)/total;

        },
        print_element(element, title) {
          this.$htmlToPaper(element, title);
        },
        get_date(date) {
          var date_format = "YYYY-MM-DD";
          var final_date = "";
          if (i18n.locale == "fa") {
            date_format = date_format.replace("YYYY", 'jYYYY')
            date_format = date_format.replace("MM", 'jMM')
            date_format = date_format.replace("DD", 'jDD')
            final_date = moment(date).locale('fa').format(date_format);
          } else {
            final_date = moment(date).locale('en').format(date_format);
          }
          if (final_date == "Invalid date") {
            final_date = date;
          }
          return final_date;

        },
        get_date_time(date) {
          var date_format = "YYYY/MM/DD";
          var final_date = "";
          if (i18n.locale == "fa") {
            date_format = date_format.replace("YYYY", 'jYYYY')
            date_format = date_format.replace("MM", 'jMM')
            date_format = date_format.replace("DD", 'jDD')
            final_date = moment(date).locale('fa').format(date_format);
          } else {
            final_date = moment(date).locale('en').format(date_format);
          }
          if (final_date == "Invalid date") {
            final_date = date;
          }
          return final_date + " " + moment(date).format('HH:mm');

        },
       get_logo() {
          return localStorage.getItem('app_logo');
        },

        my_branch_code() {
          return localStorage.getItem('branchCode');
        },
        get_user_name() {
          return localStorage.getItem("user_name");
        },

        get_today() {
          if (i18n.locale == "fa") {
            return moment().locale('fa').format('YYYY-MM-DD');
          } else {
            return moment().locale('en').format('YYYY-MM-DD');
          }
        },

        get_day_before_today(month) {
          if (i18n.locale == "fa") {
            return moment().subtract(month, 'month').locale('fa').format('YYYY-MM-01');
          } else {
            return moment().subtract(month, 'month').locale('en').format('YYYY-MM-01');
          }
        },
        get_day_before_today_in_day(day) {
          if (i18n.locale == "fa") {
            return moment().subtract(day, 'day').locale('fa').format('YYYY-MM-DD');
          } else {
            return moment().subtract(day, 'day').locale('en').format('YYYY-MM-DD');
          }
        },
        get_access(access) {
          return JSON.parse(localStorage.getItem("config_permissions"))[access];
        },
        has_permission(access) {
          let permissions = localStorage.getItem("permissions");
          return permissions.includes(access);

        },
        isEnglish(e) {
          let char = String.fromCharCode(e.keyCode); // Get the character
          if (/^[A-Za-z0-9 ]+$/.test(char)) return true; // Match with regex
          else e.preventDefault(); // If not match, don't add to input text
        },
        isNumber(e) {
          let char = String.fromCharCode(e.keyCode); // Get the character
          if (/^[0-9]+$/.test(char)) return true; // Match with regex
          else e.preventDefault(); // If not match, don't add to input text
        },
        isDecimal(e) {
          let char = String.fromCharCode(e.keyCode); // Get the character
          if (/^[0-9.]+$/.test(char)) return true; // Match with regex
          else e.preventDefault(); // If not match, don't add to input text
        },
        isDecimal2(e, price) {

          let char = String.fromCharCode(e.keyCode); // Get the character
          if (char == "." && price.toString().includes('.')) {
            e.preventDefault();
          }
          var fixed = parseInt(2);
          var price_array = price.toString().split(".");
          if (price_array[1] != null && fixed == price_array[1].length) {
            e.preventDefault();
          }
          if (/^[0-9.]+$/.test(char)) return true; // Match with regex
          else e.preventDefault(); // If not match, don't add to input text
        },
        isDecimal_no_fix(e, price) {
          try {
            let char = String.fromCharCode(e.keyCode); // Get the character
            if (char == "." && price.toString().includes('.')) {
              e.preventDefault();
            }
            var fixed = 7;
            var price_array = price.toString().split(".");
            if (price_array[1] != null && fixed == price_array[1].length) {
              e.preventDefault();
            }
            if (/^[0-9.]+$/.test(char)) return true; // Match with regex
            else e.preventDefault(); // If not match, don't add to input text
          } catch (e) {

          }

        },
        sort_array(fabric_array, unsorted, id_key, label_key) {
          var tmpAry = new Array();

          for (var i = 0; i < unsorted.length; i++) {
            // tmpAry[i] = {value:unsorted[i][id_key],label:unsorted[i][label_key]}
            tmpAry[i] = unsorted[i];
            tmpAry[i].value = unsorted[i][id_key];
            tmpAry[i].label = unsorted[i][label_key];

          }
          // console.log(tmpAry)
          tmpAry.sort((a, b) => a.label.localeCompare(b.label, undefined, {numeric: true, sensitivity: 'base'}));

          fabric_array.push(...tmpAry)
          return fabric_array;

        },

      }
    }
);

fetch('/x_config.json?ver=' + process.env.VUE_APP_VERSION).then(res => res.json()).then(config => {

  localStorage.setItem("web_address", config.web_address);
  // API base URL + auth live in src/api (single source); x_config.json only carries web_address now

  // axios.defaults.withCredentials = true;
  create_vue()

})


function create_vue() {
  app.use(router)
  app.use(store)
  app.use(i18n)
  app.mount('#app')
}
